import { useState } from "react";
import { fr } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CalendarDays } from "lucide-react";

// French date + time picker; returns an ISO string through onPick
export function DateTimePick({ disabled, onPick }) {
  const [day, setDay] = useState(null);
  const [time, setTime] = useState("23:59");
  const [open, setOpen] = useState(false);
  const apply = () => {
    const [h, m] = time.split(":").map(Number);
    const d = new Date(day);
    d.setHours(h || 0, m || 0, 0, 0);
    onPick(d.toISOString());
  };
  return (
    <div className="flex gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="h-9 flex-1 justify-start bg-[#060B14] border-[#1A2332] text-white" data-testid="retention-date-input">
            <CalendarDays className="w-4 h-4 mr-2 text-[#64748B]" />{day ? day.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "Choisir une date"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-[#0B1120] border-[#1A2332] text-white" align="start">
          <Calendar mode="single" locale={fr} selected={day} onSelect={(d) => { setDay(d); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      <Input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="w-28 h-9 bg-[#060B14] border-[#1A2332] text-white" data-testid="retention-time-input" />
      <Button size="sm" variant="outline" disabled={disabled || !day} onClick={apply} className="h-9 bg-transparent border-[#1A2332] text-white" data-testid="retention-set-date-btn">Definir la date</Button>
    </div>
  );
}
